import IChatOrder from "@/interfaces/chatOrder";
import gql from "@/repo/apolloClient";
import { showNotification } from "@/utility";
import { makeAutoObservable, runInAction } from "mobx";
import Logo from "@/assets/icons/P2P_Logo.svg";

interface State {
  orderMessages: IChatOrder[] | null;
  myOrderMessages: IChatOrder[] | null;
  myLatestOrderMessages: IChatOrder[] | null;
}
export class ChatOrderStore {
  private state: State = {
    orderMessages: null,
    myOrderMessages: null,
    myLatestOrderMessages: null,
  };
  constructor() {
    makeAutoObservable(this);
  }
  public get orders() {
    return this.state.orderMessages;
  }

  public sendMessage = async (
    id: string,
    content: string,
    participants: string[],
    message_type: "text" | "image" | "status",
  ) => {
    const query = `
      mutation sendMessage($participants: String!,$order_id: uuid!,$message_type: String!) {
        insert_chat_order_messages_one(object: { participants: $participants ,content: "${content}", order_id: $order_id, message_type: $message_type }) {
          message_id
        }
      }
    `;
    await gql.Mutation(query, {
      participants: JSON.stringify(participants)
        .replace("[", "")
        .replace("]", "")
        .replaceAll('"', ""),
      order_id: id,
      message_type,
    });
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private handleMyOrderMessagesUpdate = (response: any) => {
    const messages = response.data.chat_order_messages ?? null;

    runInAction(() => {
      this.state.myOrderMessages = messages ?? null;

      const latestMessageTimestamp = localStorage.getItem(
        "latestOrderMessageTimestamp",
      );

      const latestTimestamp = latestMessageTimestamp
        ? Number(latestMessageTimestamp)
        : null;
      const currentURL = window.location.hash;
      let notifyCount = 0;

      for (const message of messages) {
        const messageTimestamp = new Date(message.created_at).getTime();
        const orderPageURL = "#/trade/orders/" + message.order_id;

        if (notifyCount === 5) break;

        if (
          (!latestTimestamp || messageTimestamp > latestTimestamp) &&
          orderPageURL !== currentURL
        ) {
          console.log("show notification");
          notifyCount += 1;
          showNotification({
            title: "New order's message!",
            body: "You have received a new message. Click to go to order chat.",
            icon: Logo,
            path: "/" + orderPageURL,
          });
        }
      }

      const latestMessage = messages[messages.length - 1];
      if (latestMessage) {
        const latestMessageTimestamp = new Date(latestMessage.created_at)
          .getTime()
          .toString();
        localStorage.setItem(
          "latestOrderMessageTimestamp",
          latestMessageTimestamp,
        );
      }
    });
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private handleOrderMessagesUpdate = (response: any) => {
    runInAction(() => {
      this.state.orderMessages = response.data.chat_order_messages ?? null;
    });
  };

  public subscribeToMyOrderMessages = async (user_id: string) => {
    const query = `
    subscription GetLatestMessages {
      chat_order_messages(
        where: { created_by: { _neq: "${user_id}" } }
        order_by: { created_at: asc }
      ) {
        message_id
        message_type
        content
        created_at
        order_id
        created_by
        participants
      }
    }
    `;
    const subscription = (await gql.Subscribe(query)).subscribe({
      next: this.handleMyOrderMessagesUpdate,
      error: (error) =>
        console.error("Error fetching my order messages: ", error),
    });

    return () => subscription.unsubscribe();
  };
  public subscribeToOrderMessages = async (order_id: string) => {
    const query = `
    subscription OnChatMessage {
      chat_order_messages(where: { order_id: { _eq: "${order_id}" } }) {
        content
        message_id
        order_id
        message_type
        created_at
        created_by
        participants
      }
    }
  `;
    const subscription = (await gql.Subscribe(query)).subscribe({
      next: this.handleOrderMessagesUpdate,
      error: (error) => console.error("Error fetching order messages: ", error),
    });

    return () => subscription.unsubscribe();
  };

  public get myOrderMessages() {
    return this.state.myOrderMessages;
  }
  public get orderMessages() {
    return this.state.orderMessages;
  }
}
